import { RadioOption, SimNaoEnum } from 'components/form'

import { PerguntaRadioGroupBoxField, PerguntaRadioGroupBoxFieldProps } from './PerguntaRadioGroupBoxField'

type PerguntaSimNaoRadioGroupBoxFieldProps = Omit<PerguntaRadioGroupBoxFieldProps<SimNaoEnum>, 'options'>

export function PerguntaSimNaoRadioGroupBoxField(props: Readonly<PerguntaSimNaoRadioGroupBoxFieldProps>) {
  return <PerguntaRadioGroupBoxField options={options} {...props} />
}

const options: RadioOption<SimNaoEnum>[] = [
  {
    label: 'Sim',
    value: SimNaoEnum.SIM,
  },
  {
    label: 'Não',
    value: SimNaoEnum.NAO,
  },
]
